import {Evaluator, registerNode} from "@cm/graph-v2-final"
import {ImageOpNodeAffineTransform} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/affine-transform/node"
import {Matrix3x2} from "@cm/math"
import {AnyImageOpContext, ImageOpOutputs} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {definition} from "@app/textures/texture-editor/operator-stack/operators/shift/node/definition"
import {ImageOpNodeBag} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/image-op-node-bag"
import {CompositeImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/composite-image-op-node"

@registerNode
export class ImageOpNodeOperatorShift extends CompositeImageOpNode<typeof definition> {
    static nodeClass = "ImageOpNodeOperatorShift"
    static definition = definition

    override async execute(evaluator: Evaluator<AnyImageOpContext>, imageOpNodeBag: ImageOpNodeBag): Promise<ImageOpOutputs<typeof definition>> {
        const {sourceImage, shiftInPixels} = await evaluator.getAll(this.parameters)
        const result = imageOpNodeBag.getNode("shift", ImageOpNodeAffineTransform, {
            sourceImage: sourceImage,
            transform: new Matrix3x2().translate(shiftInPixels),
            addressMode: "wrap",
        })
        return await evaluator.get(result)
    }
}
